import React, { useState, useEffect, useCallback, useMemo } from 'react';
import DataTable from 'react-data-table-component';
import { TablePagination } from 'react-md';
import "./style.css";
import { TiArrowSortedUp, TiArrowSortedDown } from "react-icons/ti";
import { TextField, InputAdornment } from '@mui/material';
import { BeatLoader } from 'react-spinners';
import { IoSearchSharp } from "react-icons/io5";


const customStyles = {
    headCells: {
        style: {
            fontSize: '14px',
            fontWeight: 'bold',
        },
    },
    rows: {
        style: {
            // minHeight: '48px', 
            '&:hover': {
                backgroundColor: '#eef7ff',
                // backgroundColor: '#bb000008',
                cursor: 'pointer',
            },
        },
    }
};

const DEFAULT_ROWS_PER_PAGE = 20;

const SFCustomTable = (props) => {

    const [data, setData] = useState([]);
    const [slicedData, setSlicedData] = useState([]);
    const [selectedData, setSelectedData] = useState([]);
    const [rowsPerPageValue, setRowsPerPageValue] = useState(props.rowsPerPage ?? DEFAULT_ROWS_PER_PAGE);
    const [searchText, setSearchText] = useState("");

    useEffect(() => {
        if (props.data) {
            setData(props.data);
            setSlicedData(props.data.slice(0, rowsPerPageValue));
        }

    }, [props.data]);

    useEffect(() => {
        if (props.selectedData) {
            setSelectedData([...props.selectedData]);
        }
    }, [props.selectedData])


    const onPagination = (start, rowsPerPage) => {
        setRowsPerPageValue(rowsPerPage);
        let tempSlicedData = data.slice(start, start + rowsPerPage);
        setSlicedData(tempSlicedData);
    }

    const handleSearchText = (e) => {
        let val = e.target.value;

        let tempData = data.filter(ele => {
            return props.searchByFields.some(field => {
                let fieldValue = ele[field];
                return fieldValue && fieldValue.toString().toLowerCase().includes(val.toLowerCase());
            });
        });
        setSlicedData(tempData);
        setSearchText(val);
    }

    return (
        <div style={{ position: "relative" }} className="sf-custom-table">
            {props.showSearch ?
                <div style={{ marginBottom: '1rem', marginTop:'8px',
                    position:'absolute',
                    left: 0,
                    right: 0,
                    zIndex: 2,
                    width:'400px'
                 }}>
                    <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', width:'100%'}}>
                        <TextField
                            variant='outlined'
                            style={{
                                background: 'white',
                                width: '400px'
                            }}
                            placeholder={props.searchPlaceholder ? props.searchPlaceholder : "Search"}
                            size='small' fullWidth
                            onChange={handleSearchText}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <IoSearchSharp />
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <div>
                            {props.btn}
                        </div>
                    </div>
                </div>
                : null}
            
            {props.rightContent ? (
                <div 
                className='sf-custom-table-right-content'>
                    {props.rightContent}
                </div>
            ) : null}

                <div className='sf-custom-table-top-pagination' style={{
                    opacity: props.topPagination ? 1 : 0,
                    pointerEvents: props.topPagination ? "auto" : "none"
                }}>
                    <TablePagination
                        rowsPerPageItems={[10, 20, 50, 100, 200]}
                        defaultRowsPerPage={props.rowsPerPage ?? DEFAULT_ROWS_PER_PAGE}
                        rows={data?.length}
                        rowsPerPage={rowsPerPageValue}
                        rowsPerPageLabel=""
                        onPagination={onPagination}
                    />
                </div>
            <div className="sf-data-table-scroll-wrapper">
                <DataTable
                    style={{
                        width:"100%",
                        
                    }}
                    progressPending={props.loading}
                    progressComponent={
                        <div style={{
                            padding: "40px 0",
                            textAlign: "center",
                            color: "#555",
                            fontSize: "16px",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: "12px"
                        }}>
                            <BeatLoader size={12} color="#bb0000" />
                            <div>Fetching data</div>
                        </div>
                    }
                    columns={props.columns}
                    data={slicedData}
                    onRowClicked={props.handleRowClick}
                    selectableRows={props.selectableRows}
                    onSelectedRowsChange={props.onSelectedRowsChange}
                    customStyles={customStyles}
                    selectableRowSelected={(row) => {
                        if (selectedData.includes(row.userid)) {
                            return row;
                        }
                    }}
                    sortIcon={<div
                        style={{
                            color: '#576271'
                        }}>
                        <TiArrowSortedDown />
                    </div>}
                />
            </div>
            {props.bottomPagination ?
                <div className='sf-custom-table-bottom-pagination'>
                    <TablePagination
                        rowsPerPageItems={[10, 20, 50, 100, 200]}
                        defaultRowsPerPage={props.rowsPerPage ?? DEFAULT_ROWS_PER_PAGE}
                        rows={data?.length}
                        rowsPerPage={rowsPerPageValue}
                        rowsPerPageLabel=""
                        onPagination={onPagination}
                    />
                </div>
                : null}
        </div>
    );
}

export default SFCustomTable;
